import { Redirect, Route } from "react-router-dom";

import { PageLoader } from "@/Components";
import { useInfo } from "@/context/InfoProvider/InfoProvider";
import { hasAccess } from "@/Utils/ShowComponent";

export const ProtectedRoute = ({ component: Component, requireRole, ...args }) => {
  const { userData, loading } = useInfo();

  return (
    <Route
      {...args}
      render={(props) => {
        if (loading) return <PageLoader />;
        return hasAccess(userData, requireRole) ? (
          <Component {...props} />
        ) : (
          <Redirect
            to={{
              pathname: "/",
              state: {
                from: props.location,
              },
            }}
          />
        );
      }}
    />
  );
};
